/**
 * Import required libraries
 */
import React from "react";
import { useLabel } from "Utils"
import clsx from "clsx"
/**
 * Import required elements
 */
// Material-ui components
import {
  CircularProgress,
  LinearProgress,
  Box,
  Typography
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles"

/**
 * Loading Component
 */
function Loading({
  size = 160,
  type = "circular",
  determinate = false,
  variant = "indeterminate",
  value = 0,
  thickness = 3,
  color = "primary"
}) {
  const classes = styles()
  return React.createElement(
    type === "circular" ? CircularProgress : LinearProgress,
    Object.assign({
      className: classes.progress,
      size,
      thickness,
      color,
      variant: determinate ? "determinate" : variant
    }, determinate ? { value } : null)
  )
}

function LoadingWithLabel(props) {
  const label = useLabel(props.label)
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <Loading {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">
          {label}
        </Typography>
      </Box>
    </Box>
  )
}

const Wrapper = props => {
  const { absolute, className } = props
  const classes = styles()
  return (
    <div className={clsx(absolute ? classes.absolute : classes.relative, className)}>
      {React.createElement(props.label ? LoadingWithLabel : Loading, props)}
    </div>
  )
}

const styles = makeStyles(theme => ({
  absolute: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)"
  },
  relative: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    alignItems: "center",
  },
  progress: {
    minWidth: 160,
    minHeight: 20
  }
}));

export default Wrapper;
